<template>
	<Button
		class="color-link"
		v-if="link"
		:type="color"
		:small="small"
		:uppercase="uppercase"
		:has-icon="icon"
		link
		:outlined="outlined"
	>
		<AcfLink :data="link" />
	</Button>
</template>

<script>
import Button from '@/components/elements/Button'
import AcfLink from '@/components/elements/AcfLink'

export default {
	name: 'color-link',
	props: {
		link: Object,
		outlined: {
			type: Boolean,
			default: false,
		},
		uppercase: {
			type: Boolean,
			default: false,
		},
		icon: {
			type: Boolean,
			default: false,
		},
		small: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: 'black',
		},
	},
	components: {
		Button,
		AcfLink,
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.color-link {
}
</style>
